import { render, staticRenderFns } from "./AddClientTPA.vue?vue&type=template&id=b9000c44&"
import script from "./AddClientTPA.vue?vue&type=script&lang=js&"
export * from "./AddClientTPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports